// extracted by mini-css-extract-plugin
export default {"root":"companyFilters_root__DhyYk"};